"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSocialWallProperty = exports.socialWallPropertyDefinition = void 0;
exports.socialWallPropertyDefinition = {
    view: {
        label: 'Social wall',
        hint: 'Enter a Pixlee ID/URL',
    },
    constraints: [
        {
            name: 'providers',
            argument: ['Pixlee'],
        },
    ],
    type: 'service',
    multiple: true,
    name: 'social-wall',
};
const isSocialWallProperty = (prop) => {
    return prop.name === exports.socialWallPropertyDefinition.name;
};
exports.isSocialWallProperty = isSocialWallProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29jaWFsLXdhbGwucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9zb2NpYWwtd2FsbC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDRCQUE0QixHQUFHO0lBQzFDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxhQUFhO1FBQ3BCLElBQUksRUFBRSx1QkFBdUI7S0FDOUI7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxDQUFDLFFBQVEsQ0FBQztTQUNyQjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFNBQVM7SUFDZixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxhQUFhO0NBQ1ksQ0FBQTtBQUkxQixNQUFNLG9CQUFvQixHQUFHLENBQUMsSUFBa0IsRUFBOEIsRUFBRTtJQUNyRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssb0NBQTRCLENBQUMsSUFBSSxDQUFBO0FBQ3hELENBQUMsQ0FBQTtBQUZZLFFBQUEsb0JBQW9CLHdCQUVoQyJ9